import { useEffect, useState } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { trackMarketingPageView } from "@/lib/marketing-analytics";

/** Skip duplicate Meta/GA page_view when first document load is already `/homepage` (index.html already sent). */
let skippedInitialHomepagePop = false;
import CommunityStats from "@/components/homepage/CommunityStats";
import CuratorSection from "@/components/homepage/CuratorSection";
import Hero from "@/components/homepage/Hero";
import HomepageFooter from "@/components/homepage/HomepageFooter";
import HomepageLeadModal from "@/components/homepage/HomepageLeadModal";
import HomepageStickyCta from "@/components/homepage/HomepageStickyCta";
import InviteSection from "@/components/homepage/InviteSection";
import Navbar from "@/components/homepage/Navbar";
// import SpeakingSection from "@/components/homepage/SpeakingSection";
import AIUpdates from "@/components/homepage/AIUpdates";
import WhyCommunity from "@/components/homepage/WhyCommunity";
import FeaturedThisWeek from "@/components/resources/FeaturedThisWeek";

const HOMEPAGE_CTA_HASH = "#homepage-cta";

export default function Homepage() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const [leadModal, setLeadModal] = useState<{ open: boolean; email: string }>({
    open: false,
    email: "",
  });

  useEffect(() => {
    const path =
      (location.pathname.replace(/\/$/, "") || "/") + location.search;
    const isHomepageRoute =
      path === "/homepage" || path.startsWith("/homepage?");
    if (
      isHomepageRoute &&
      navigationType === "POP" &&
      !skippedInitialHomepagePop
    ) {
      skippedInitialHomepagePop = true;
      return;
    }
    trackMarketingPageView();
  }, [location.pathname, location.search, navigationType]);

  useEffect(() => {
    if (location.hash !== HOMEPAGE_CTA_HASH) return;
    const timer = window.setTimeout(() => {
      document.getElementById("homepage-cta")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 50);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash]);

  const openLeadModal = (email: string) => {
    setLeadModal({ open: true, email });
  };

  const closeLeadModal = () => {
    setLeadModal({ open: false, email: "" });
  };

  return (
    <main
      className="flex min-h-svh w-full flex-col bg-black pb-24 text-white max-md:pb-[calc(5rem+env(safe-area-inset-bottom,0px))]"
      style={{ fontFamily: "var(--font-fira)" }}
    >
      <Navbar />
      <Hero onEmailContinue={openLeadModal} />
      <WhyCommunity />
      <CommunityStats />
      <AIUpdates />
      <FeaturedThisWeek />
      <CuratorSection />
      <InviteSection />
      {/* <SpeakingSection /> */}
      <HomepageFooter onEmailContinue={openLeadModal} />
      <HomepageStickyCta onEmailContinue={openLeadModal} />
      <HomepageLeadModal
        open={leadModal.open}
        initialEmail={leadModal.email}
        onClose={closeLeadModal}
      />
    </main>
  );
}
